import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "responsiveShow" }
const _hoisted_2 = ["alt", "src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "mainImage" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        alt: _ctx.$t('city.app_name'),
        src: _ctx.storageUrl + '/cityNameResponsive.svg'
      }, null, 8, _hoisted_2),
      _hoisted_3
    ]),
    _hoisted_4
  ], 64))
}